// extracted by mini-css-extract-plugin
module.exports = {"image":"style_image_3sRq3"};